import { FC, PropsWithChildren } from 'react';

import { Box } from '@chakra-ui/react';

import bgMobile from '@/assets/images/Olybet-bg-mobile.png';
import bg from '@/assets/images/Olybet-bg.png';

import { useSettings } from '@/hooks/useSettings';

export const GlobalBg: FC<PropsWithChildren> = ({ children }) => {
  const { isDesktop } = useSettings();
  return (
    <Box
      bgImage={`url(${isDesktop ? bg : bgMobile})`}
      bgPos='top'
      bgRepeat='no-repeat'
      bgSize='cover'
    >
      {children}
    </Box>
  );
};
